



























































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import CustomForm from '@/components/custom-form/index.vue'
import AbpBase from '@/lib/abpbase'
import UserApi from '@/api/identity/user/index'
import Permission from './operating/permission.vue'
import Util from '@/lib/util'
@Component({
  components: {
    CustomForm,
    Permission,
  },
})
export default class Member extends AbpBase {
  showPermissionModal = false
  providerKey = ''
  isCheckAll: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0
  loading: boolean = false

  columns: any[] = [
    {
      title: '成员账号',
      key: 'userName',
      align: 'center',
    },
    {
      title: '姓名',
      key: 'name',
      align: 'center',
    },
    {
      title: '邮箱地址',
      key: 'email',
      align: 'center',
    },
    {
      title: '是否禁用',
      key: 'lockoutEnabled',
      slot: 'lockoutEnabled',
      align: 'center',
    },
    {
      title: '添加时间',
      key: 'creationTime',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      type: 'action',
      width: 250,
      align: 'center',
    },
  ]
  filters = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '用户名/姓名',
      },
      key: 'filter',
    },
  ]
  submitChange(form, valid) {
    if (valid) {
      console.log('111', form, valid)
      this.getTableData(form)
    }
  }
  /**
   * 禁用
   */
  handleDisable(id) {
    this.$Modal.confirm({
      title: '提示',
      content: `是否确认此操作?`,
      onOk: () => {
        UserApi.disabledUser(id).then((res) => {
          this.$Message.success('禁用成功')
          this.getTableData()
        })
      },
    })
  }
  /**
   * 启用
   */
  handleEnable(id) {
    this.$Modal.confirm({
      title: '提示',
      content: `是否确认此操作?`,
      onOk: () => {
        UserApi.enableUser(id).then((res) => {
          this.$Message.success('启用成功')
          this.getTableData()
        })
      },
    })
  }
  /**
   * 获取角色列表
   */
  getTableData(form = {}) {
    this.isCheckAll = false
    let filter = form['filter']
    let { pageSize, currentPage } = this
    let published = false
    this.loading = true
    UserApi.getUsers(pageSize, currentPage, filter)
      .then((res) => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }
  mounted() {
    this.submitFn()
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  handleTableAllCancel() {
    this.isCheckAll = false
  }
  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }
  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }
  change(status) {
    this.$Message.info('开关状态：' + status)
  }
  // 权限编辑
  editPermission(id?) {
    console.log(id)
    this.$router.push({
      name: 'editUser',
      query: {
        id,
      },
    })
  }
  // 删除
  deletePermission(id) {
    console.log(id)
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        UserApi.deleteUser(id).then((res) => {
          this.$Message.success('删除成功')
          this.getTableData()
        })
      },
    })
  }
  addNewMember() {
    console.log('新增成员')
    this.$router.push({
      name: 'addUser',
    })
  }
  // 权限设置
  permissionSettings(item) {
    this.providerKey = item.id
    this.showPermissionModal = true
  }
}
